import type { Route } from '@angular/router';
import { userLimitAdmin } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const userLimitAdminRoute: Route = {
  path: 'limits',
  loadComponent: () =>
    import('./user-limit-admin-list.component').then(
      (mod) => mod.UserLimitAdminListComponent,
    ),
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('./form/user-limit-admin-form.component').then(
          (mod) => mod.UserLimitAdminFormComponent,
        ),
      canDeactivate: [CanDeactivateGuard],
    },
    {
      path: 'preview/:id/history/:tableName',
      loadComponent: () =>
        import('@clean-code/shared/components/ui-auditable-history').then(
          (mod) => mod.AuditableHistoryDetailsComponent,
        ),
    },
  ],
  canActivate: [ngxPermissionsGuard],
  data: {
    permissions: {
      only: [userLimitAdmin],
    },
  },
};
